(ns web3.screens.parent
  (:require [reagent.core :as r]
            [re-frame.core :as rf]
            [web3.i18n :as i]
            [web3.routing.core :as routing]
            [web3.components.parent :as parent]
            [web3.utils :as utils]
            [web3.view :as v]
            [web3.queries.asset :as q-asset]
            [web3.persistence.current-property :as current-property]))

;; ========== Views ==========

(defn nav-back!
  []
  (rf/dispatch [:routing/nav (routing/drop-segments 1 :router/form-modal)]))

(defn set-parent!
  [id]
  (parent/notify-change! id)
  (nav-back!))

(defn valid-modal-props?
  []
  (let [{:keys [change-value! on-change]} (parent/props)]
    (or change-value!
        on-change)))

(defn parent-list-item-props
  [{:keys [id title]
    :as props}]
  (->> {:key id
        :selected? (= id (:value (parent/props)))
        :on-select (partial set-parent! id)}
       (merge props)))

(defn toggle-expand!
  [{:keys [state]} id]
  (swap! state update :expanded utils/toggle-set id))

(v/defview select-parent
  {:component-did-mount
   (fn [_]
     (when-not (valid-modal-props?)
       (nav-back!)))}
  []
  (let [{:keys [state] :as this} (r/current-component)
        {:keys [assetGroups id nickname]} (current-property/get-property)]
    [parent/parent-select-list
     {:on-create
      (fn [{:keys [id] :as group}]
        (set-parent! id))
      :items (let [{:keys [root
                           root-type
                           traverse-up?
                           traverse-down?
                           allowed-types]
                    :as parent-context} (parent/get-parent-context)

                   ;; if root is a group, and we can't traverse-up?, limit results to current group
                   groups (->> (cond->> assetGroups
                                        (and (= root-type "AssetGroup")
                                             (false? traverse-up?)) (filter #(= root (:id %))))
                               (filter #(not (:sample %))))

                   groups (->> (for [{:keys [id name]} groups
                                     :let [expanded? (get-in @state [:expanded id])
                                           {:keys [assets]} (q-asset/fetch-group id)
                                           children (when (allowed-types "Asset")
                                                      (->> (doall
                                                            (for [{:keys [id] :as asset} assets]
                                                              {:id id
                                                               :title (parent/asset-name asset)}))
                                                           (map parent-list-item-props)
                                                           (sort-by :title)))]]
                                 {:id id
                                  :title (cond-> name
                                                 assets (str " (" (count assets) ")"))
                                  :expanded? expanded?
                                  :default-expanded? (= (count children) 1)
                                  :on-expand-toggle (when (seq children)
                                                      (partial toggle-expand! this id))
                                  :class ""
                                  :children children})
                               (sort-by :title))
                   property {:id (or id "property")
                             :title (->> :select-parent/this-property
                                         i/get
                                         utils/wrap-parens
                                         (str nickname " "))
                             :class "property"
                             :text-class "text-category"
                             :expanded? true}]
               (cond->> groups
                        (and (allowed-types "Property")
                             (or (= "Property" root-type)
                                 (true? traverse-up?))) (cons property)
                        true (map parent-list-item-props)))}]))
